import BusinessVerify from ".";
import type { RiskVerifyUiVariant } from "../RiskVerify/types";

/** UNO 受益人流程专用核验视图，历史 BusinessVerify 保持默认样式。 */
export default class UnoBusinessVerify extends BusinessVerify {
  protected uiVariant: RiskVerifyUiVariant = "uno";
}
